/*
 * Cart kit grouping — combined remove + cart-page reload on protection change.
 *
 * (1) Combined remove: a kit card renders all components sharing a _builder_id as one
 *     card with a single Remove; clicking it zeroes every kit line in ONE
 *     /cart/update.js call, then signals the theme so the cart + reconciler update.
 *
 * (2) Cart PAGE only reflects cart changes via a full reload (Focal reloads it for
 *     native changes; cart:refresh re-renders the DRAWER only). The shipping-protection
 *     reconciler updates the protection line asynchronously, so on the cart page the
 *     line kept showing the OLD price. We reload on the reconciler's "cart:reconciled"
 *     event — it fires ONLY when a real change was applied, so stable page loads don't
 *     reload (that avoids the earlier load-time reload storms). Guarded against loops.
 */
(() => {
  if (window.__cartKitGroupInit) return;
  window.__cartKitGroupInit = true;

  function rootUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function onCartPage() {
    return !!(window.themeVariables && window.themeVariables.settings &&
      window.themeVariables.settings.pageType === 'cart');
  }

  // ---- (2) reload the cart page when protection is (re)applied ----------------
  if (onCartPage()) {
    const GUARD = 'kitCartReconcileReloads';
    document.addEventListener('cart:reconciled', () => {
      const n = parseInt(sessionStorage.getItem(GUARD) || '0', 10);
      if (n >= 2) return; // reconciler converges in ~1 pass; cap protects against loops
      sessionStorage.setItem(GUARD, String(n + 1));
      window.location.reload();
    });
    // A load that settles without another reconcile clears the guard.
    window.addEventListener('load', () => {
      setTimeout(() => sessionStorage.removeItem(GUARD), 1800);
    });
  }

  // ---- (1) combined remove ---------------------------------------------------
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-kit-remove]');
    if (!button) return;

    event.preventDefault();
    if (button.dataset.kitBusy === '1') return;

    const keys = (button.getAttribute('data-kit-keys') || '')
      .split(',')
      .map((k) => k.trim())
      .filter(Boolean);
    if (!keys.length) return;

    button.dataset.kitBusy = '1';
    button.style.pointerEvents = 'none';
    button.style.opacity = '0.5';

    const updates = {};
    keys.forEach((key) => { updates[key] = 0; });

    fetch(rootUrl() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates })
    })
      .then((response) => response.json())
      .then((cart) => {
        // Trigger the reconciler (listens for cart:updated) so protection recalcs.
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', { bubbles: true, detail: { cart } })
        );

        if (onCartPage()) {
          // If protection changes, cart:reconciled reloads us above. Fallback reload
          // covers the case where protection needs no change, so the kit removal still
          // shows (cart already changed, page must reload to reflect it).
          setTimeout(() => window.location.reload(), 1400);
        } else {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } })
          );
        }
      })
      .catch(() => {
        if (onCartPage()) {
          window.location.reload();
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      });
  });
})();
